import { motion } from "motion/react"
import { ReactNode } from "react"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

interface AnimatedContainerProps {
  children: ReactNode
  className?: string
}

export const AnimatedContainer = ({
  children,
  className,
}: AnimatedContainerProps) => (
  <motion.div
    className={cn("relative cursor-pointer h-full", className)}
    transition={{ type: "spring", stiffness: 400, damping: 10 }}
  >
    <motion.div
      className="absolute -inset-[1px] rounded-system-md"
      style={{
        background: "transparent",
        border: "1px solid transparent",
        backgroundImage:
          "linear-gradient(#000, #000), linear-gradient(45deg, rgba(236, 72, 153, 1), rgba(244, 114, 182, 1))",
        backgroundOrigin: "border-box",
        backgroundClip: "padding-box, border-box",
      }}
      animate={{
        backgroundImage: [
          "linear-gradient(#000, #000), linear-gradient(45deg, rgba(236, 72, 153, 1), rgba(244, 114, 182, 1))",
          "linear-gradient(#000, #000), linear-gradient(180deg, rgba(236, 72, 153, 1), rgba(244, 114, 182, 1))",
          "linear-gradient(#000, #000), linear-gradient(225deg, rgba(236, 72, 153, 1), rgba(244, 114, 182, 1))",
        ],
      }}
      transition={{
        duration: 10,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "linear",
      }}
    >
      <motion.div
        className="absolute inset-[-1px] rounded-system-md"
        style={{
          background:
            "linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.8) 35%, transparent 65%)",
          backgroundSize: "300% 100%",
          opacity: 0.5,
        }}
        animate={{
          backgroundPosition: ["-100% 0%", "100% 0%", "200% 0%"],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "linear",
        }}
      />
    </motion.div>
    <div className="relative z-1 bg-system-blue-800 hover:bg-system-blue-700 transition-colors duration-200 text-white text-center flex items-center h-full px-system-lg rounded-system-md">
      {children}
    </div>
  </motion.div>
)

export default AnimatedContainer
